<template>
  <div class="seoPart childPagePart">
    <el-form :model="seo_data" :rules="rules" ref="seo_data" :label-width="$store.state.app.web_language_wm == 'en' ? '120px' : '100px'" class="demo-seo_data el-form-self-check">      
      <p v-if="seoType == 'product' ||seoType == 'article'" class="titleWords">{{$t('components_basic_addarticle_index_2008')}}</p>
      <el-form-item :label="$t('components_basic_common_seo_2167')" prop="seo_title">        
        <el-input
          v-model="seo_data.seo_title"
          :placeholder="$t('components_basic_common_seo_2168')"
          type="text"
          style="width:91%"
          :disabled="autotype == 1"
        ></el-input>
        <hoverTips :content="$store.state.app.seo_title_hover"></hoverTips>
      </el-form-item>
      <staticTips :styleWidth="'79%'" :marginLeft="$store.state.app.web_language_wm == 'en' ? 120 : 100" :marginTop="-14" :content="$store.state.app.seo_title_tips"></staticTips>

      <el-form-item v-if="false" :label="$t('components_basic_common_seo_2169')" prop="keywords">
        <div class="seo-keywords-tag">
            <el-tag
              v-for="(keywords,i) in seo_data.seo_keywords"
              :key="i"
              closable
              :disable-transitions="false"
              @close="del_keywords(i)">
              {{keywords.value}}
            </el-tag>
        </div>
        <div style="display:block" v-if="seo_data.seo_keywords.length < 5">
          <!-- @keyup.enter.native="add_keywords" -->
          <el-input
          style="width:91%"
            v-model="seo_data.keywords"
            size="large"
            :maxlength="60"
            @blur="add_keywords"
            @keyup.enter.native="add_keywords"
            :placeholder="$t('components_basic_common_seo_2170')"
          ></el-input>
          <hoverTips :content="$store.state.app.seo_keywords_hover"></hoverTips>
        </div>
      </el-form-item>
      <staticTips v-if="false" :styleWidth="'79%'" :marginLeft="$store.state.app.web_language_wm == 'en' ? 120 : 100" :marginTop="-14" :content="$store.state.app.seo_keywords_tips"></staticTips>

      <el-form-item :label="$t('components_basic_common_seo_2171')" prop="seo_description">       
        <el-input
          v-model="seo_data.seo_description"
          :placeholder="$t('components_basic_common_seo_2172')"
          type="textarea"
          resize="none"
          :disabled="autotype == 1"
          show-word-limit
          size="large"
          rows="4"
          style="width:91%"
        ></el-input>
        <hoverTips :content="$store.state.app.seo_description_hover"></hoverTips>        
      </el-form-item>
      <staticTips :styleWidth="'79%'" :marginLeft="$store.state.app.web_language_wm == 'en' ? 120 : 100" :marginTop="-14" :content="$store.state.app.seo_description_tips"></staticTips>
      <el-form-item v-if="seoType && (seoType !='nav')" label="">
        <ai_command  :type="'tkd'" @pushTkd="pushTkd" :seoTitleType="seoTitleType" :command_type ="'td'"></ai_command>
      </el-form-item>

    </el-form>

  </div>
</template>

<script>
import i18n from '../../language/index'

import { chineseRule, isNull } from "@/base/valid";
import ai_command from "../ai_command/index.vue";
export default {
  name: 'seo',
  props: {
    seoData: {
      type: Object,
      default: null
    },
    productInfor: {
      type: Object,
      default: null
    },
    autoSeo: {
      type: Object,
      default: function() {
        return {
          title: '',
          keywords: '',
          description: ''
        };
      }
    },
    seoType: {
      type: String,
      default: 'product'
    },
    seoTitleType: {
      type: String,
      default: ''
    }
  },
  components: {
    ai_command,
  },
  data() {
    const validKeywords = (rule, value, callback) => {
      let kval = this.seo_data.keywords
      let values = this.seo_data.seo_keywords.map(x => x.value);
      if(values.indexOf(kval) != -1){
          callback(new Error(i18n.t('components_basic_common_seo_2173')));
      }else{
        callback();
      }
    };
    return {
      product_infor: this.productInfor,
      seo_data: this.seoData,
      autotype: 2,
      ruleForm: {
        seo_title: '', //SEO标题
        keywords: '', //SEO关键词
        seo_keywords: '', //SEO关键词
        seo_description: '' //SEO描述
      },
      rules: {
        seo_title: [
          {
            validator: chineseRule,
            trigger: "blur"
          }
        ],
        keywords: [
          {
            validator: chineseRule,
            trigger: "blur"
          },
          {
            validator: validKeywords,
            trigger: "blur"
          }
        ],
        seo_description: [
          {
            validator: chineseRule,
            trigger: "blur"
          }
        ],
      }
    };
  },
  methods: {
    keywordBlur(rule, value, callback) {
      if (!value) callback();
      var reg = /^[A-Za-z0-9_-]{1,80}$/;
      if (!reg.test(value)) {
        callback(i18n.t('base_valid_1949'))
      } else callback()
    },
    add_keywords() {
      // this.seo_data.seo_keywords.push({value: ''})
      let kval = this.seo_data.keywords
      this.$refs['seo_data'].validateField('keywords', (errorMsg) => {
        if(!errorMsg && !isNull(kval) && this.seo_data.seo_keywords.length < 5){
            this.seo_data.seo_keywords.push({value: kval})
            this.seo_data.keywords = ''
        }
        console.log('errorMsg', errorMsg)
      })
    },
    del_keywords(index) {
      this.seo_data.seo_keywords.splice(index,1)
    },
    pushTkd(cont){
      this.seo_data.seo_title = cont.seo_title
      this.seo_data.seo_description = cont.seo_description
    }
  },
  watch: {
    seo_data(val) {
      this.$emit('update:seoData', val); //双向数据绑定
    },
    seoData(val) {
      this.seo_data = this.seoData;
    }
  },
  mounted() {
    console.log('this.seo_data', this.seo_data);
  }
};
</script>

<style scoped lang="scss">
  .seo-keywords-tag .el-tag{
    margin-right: 5px;
  }
  .el-form-self-check {
  .el-form-item.is-error {
    margin-bottom:35px !important;
  }
  .el-form-item.zi_customer {
    margin-bottom:24px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic_common/seo.vue